import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { API_URL } from "../../../config";

const StyledLessonCompleteButton = styled.button`
  width: 100%;
  text-align: center;
  padding: 10px;
  border: 1px solid ${(props) => props.theme.primaryBlue};
  color: white;
  background: ${(props) => props.theme.primaryBlue};
  font-size: 20px;
  margin-top: 2rem;
  transition: all 300ms ease;
  &:hover {
    color: ${(props) => props.theme.primaryBlue};
    background: white;
  }
  &:disabled {
    background: darkgrey;
  }
`;

const LessonCompleteButton = ({
  isCompleted,
  programPostId,
  contentfulCourseId,
  route,
  getCompletedTokens,
}) => {
  const history = useHistory();
  const markComplete = (data) =>
    axios({
      method: "POST",
      url: `${API_URL}/markComplete`,
      withCredentials: true,
      data,
    });

  const markIncomplete = (data) =>
    axios({
      method: "POST",
      url: `${API_URL}/markIncomplete`,
      withCredentials: true,
      data,
    });

  const [buttonDisabled, setbuttonDisabled] = useState(false);

  return (
    <StyledLessonCompleteButton
      disabled={buttonDisabled}
      className="toggleComplete"
      onClick={() => {
        if (isCompleted) {
          setbuttonDisabled(true);
          markIncomplete({
            programPostId,
            contentfulCourseId,
          }).then(() => {
            getCompletedTokens();
          });
        } else {
          setbuttonDisabled(true);
          markComplete({
            programPostId,
            contentfulCourseId,
          })
            .then(() => {
              getCompletedTokens();
              history.push(route);
            })
            .catch((err) => console.log(err));
        }
        window.scrollTo(0, 0);
      }}
    >
      Mark As {isCompleted ? "Inc" : "C"}omplete
    </StyledLessonCompleteButton>
  );
};

export default LessonCompleteButton;
